import { RendererType } from 'situanalytics-webapi-client';

/**
 * A virtual renderer (such as situview-api) does its work in-process: it has no machine,
 * queues, pool or health checks, and the server rejects any change to it.
 */
export function isVirtualRenderer(renderer: { rendererType?: RendererType } | null | undefined): boolean {
  return renderer?.rendererType === RendererType.Virtual;
}
